import { Component, computed, type OnDestroy, type Signal, signal } from '@angular/core';
import { RouterOutlet, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { AuthService } from './services/auth.service';
import { type Subscription } from 'rxjs';
import { NgbDropdownModule, NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { type ToastFull, ToastService } from './services/toast-service.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  imports: [RouterOutlet, NgbDropdownModule, NgbToastModule, RouterLink, RouterLinkActive]
})
export class AppComponent implements OnDestroy {
  #id = 0;
  get id() {
    return this.#id;
  }
  readonly username = signal<string | null>(null);
  readonly #roles = signal<string[]>([]);
  readonly #sub: Subscription;
  readonly toasts: Signal<ToastFull[]>;
  readonly removeToast: (toast: ToastFull) => void;
  constructor(
    private svc: AuthService,
    private router: Router,
    toast: ToastService
  ) {
    this.toasts = toast.toasts;
    this.removeToast = (a: ToastFull) => toast.remove(a);
    this.#sub = svc.isLogged().subscribe(a => {
      if (a) {
        this.#id = a.id;
        this.username.set(a.name);
        this.#roles.set(a.roles);
      } else {
        this.#id = 0;
        this.username.set(null);
        this.#roles.set([]);
      }
    });
  }

  hasRole(...role: string[]): Signal<boolean> {
    return computed(() => {
      const roles = this.#roles();
      return role.some(r => roles.includes(r));
    });
  }

  login() {
    this.svc.requestLogin().subscribe();
  }

  logout() {
    this.svc.logout().subscribe(() => this.router.navigate(['/']));
  }

  ngOnDestroy() {
    this.#sub.unsubscribe();
  }

  updateRoles() {
    this.svc.isLogged(true).subscribe(a => {
      if (a) {
        this.#roles.set(a.roles);
      } else {
        this.#roles.set([]);
      }
    });
  }
}
